import ProductCategory from ".";

export const productCategoryRoutes = () => [
  {
    path: "/admin/product-categories",
    component: ProductCategory,
    layout: "admin",
    routeType: "admin",
    title: "Products Management",
  },
];
